import { render, staticRenderFns } from "./GoldenSpin.vue?vue&type=template&id=0041521c&scoped=true&"
import script from "./GoldenSpin.vue?vue&type=script&lang=js&"
export * from "./GoldenSpin.vue?vue&type=script&lang=js&"
import style0 from "./GoldenSpin.vue?vue&type=style&index=0&id=0041521c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0041521c",
  null
  
)

export default component.exports